/**
 * @fileoverview Registration corporate identity section.
 * @module components/AppointmentRegistrationSections/CorporateIdentity/index
 */
import styles from "./CorporateIdentity.module.css";
import { useCorporateIdentityForm } from "./useCorporateIdentityForm.js";
import CorporateIdentityNameFields from "./CorporateIdentityNameFields.jsx";
import CorporateIdentityProfileFields from "./CorporateIdentityProfileFields.jsx";

const CorporateIdentity = ({
  company,
  onFieldChange,
  onValidationChange,
  getFieldValidation,
  missingRequiredFields,
}) => {
  const form = useCorporateIdentityForm({
    company,
    onFieldChange,
    onValidationChange,
  });

  return (
    <div className={styles.sectionContent}>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>
          {form.t("components.corporateIdentity.title")}
        </span>
        <div className={styles.sectionDivider}></div>
      </div>
      <CorporateIdentityNameFields
        company={company}
        styles={styles}
        form={form}
        getFieldValidation={getFieldValidation}
        missingRequiredFields={missingRequiredFields}
      />
      <CorporateIdentityProfileFields
        company={company}
        styles={styles}
        form={form}
        getFieldValidation={getFieldValidation}
        missingRequiredFields={missingRequiredFields}
      />
    </div>
  );
};

export default CorporateIdentity;
